<div class="page-name">
  <h3>{{ 'vouchers.page-name' | translate }}</h3>
</div>

<div class="profile-navigation">
  <div class="item" (click)="navigateAccount()">
    <p class="subtitle-14">{{ "account-navigation.account" |  translate }}</p>
  </div>

  <div class="item" (click)="navigateContactUs()">
    <p class="subtitle-14">{{ "account-navigation.contact-us" |  translate }}</p>
  </div>

  <div class="item active">
    <p class="subtitle-14">{{ "account-navigation.vouchers" |  translate }}</p>
  </div>
</div>

<div class="vouchers-list">
  @for (voucher of vouchers; track voucher) {
    <div class="voucher-item" (click)="openVoucher(voucher)">
      <div class="icon-part">
        <mat-icon svgIcon="notification-voucher"></mat-icon>
      </div>
      <div class="content-part">
        <div class="voucher-title-row">
          <p class="subtitle-14 voucher-title">{{ 'vouchers.partner-title' | translate:voucher.values }}</p>
        </div>
        <div class="voucher-code">
          <p class="body-12">{{ 'vouchers.code' | translate }}: {{ voucher.values['couponCode'] }}</p>
        </div>
        <div class="voucher-date">
          <p class="body-12">{{ voucher.dateCreated | date: 'dd.MM.yyyy' }}</p>
        </div>
      </div>
      <div class="arrow-part">
        <mat-icon svgIcon="expand-up"></mat-icon>
      </div>
    </div>
  }

  @if (!loading && vouchers.length === 0) {
    <div class="empty-item">
      <div class="icon-part">
        <mat-icon svgIcon="notification-voucher"></mat-icon>
      </div>
      <div class="content-part">
        <p class="subtitle-14">{{ 'vouchers.empty-state-message' | translate }}</p>
      </div>
      <div class="arrow-part">
        <!-- Empty space to maintain layout -->
      </div>
    </div>
  }
</div>
